import cn from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Alert } from '@/components/atom';
import styles from './alerts.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Alerts extends React.PureComponent {
  static get propTypes() {
    return {
      alerts: PropTypes.object,
      removeAlert: PropTypes.func
    };
  }
  constructor(props) {
    super(props);
    this.rootNode = document.body;
  }
  render() {
    const {
      alerts
    } = this.props;
    if (Object.keys(alerts).length <= 0) {
      return null;
    }
    return /*#__PURE__*/ReactDOM.createPortal(this._renderAlerts(), this.rootNode);
  }
  _renderAlerts() {
    const {
      alerts,
      removeAlert
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: Object.values(alerts).map(alert => {
        const {
          id,
          content,
          hidden,
          ...rest
        } = alert;
        return /*#__PURE__*/_jsx(Alert, {
          onClick: () => removeAlert(id),
          className: cn(styles.alert, {
            [styles['alert--hidden']]: hidden
          }),
          ...rest,
          children: content
        }, id);
      }).reverse()
    });
  }
}